import { Contact } from "@app/core/contact/domain/contact";
import { Observable } from "rxjs";

export abstract class ContactRepo {
  abstract sendMessage(message: Contact, token: string): Observable<void>;
  abstract getWhatsappContactNumber(): Observable<string>;
}
